import { type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const ResourcesPageLayout = ({ children }: Props) => (
  <div className="px-14 py-16">{children}</div>
);
